<template src='./fileUpload.pug' lang='pug'></template>

<script>
import _ from 'underscore'
import Dropzone from 'vue2-dropzone'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import axios from '../../../../../build/http-requests/axios-common.js'
import getNodeMiddlewareUrl from '../../../../../build/http-requests/getNodeMiddlewareUrl'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import { truncateString } from '../../../../utils/truncateString.js'

export default {
  name: 'FileUpload',

  components: {
    Dropzone,
    PageTitle,
    FilterPortlet,
    ButtonPrimary
  },

  data () {
    return {
      layouts: null,
      availableLayouts: [],
      isLoadingData: true,
      msgError: 'uploadArquivo.erro.geral',
      showInnerMessage: false,
      useCustomDropzoneOptions: true,
      dropzoneOptions: {
        showRemoveLink: false,
        maxFileSizeInMB: 1024,
        maxNumberOfFiles: 100000000,
        parallelUploads: 5,
        timeout: 50000,
        autoProcessQueue: false,
        autoQueue: false,
        error: function (file, message) {
          file.previewElement.classList.add('dz-error')
          let refs = file.previewElement.querySelectorAll('[data-dz-errormessage]')
          let results = []
          refs.forEach(ref => {
            results.push(ref.textContent = message)
          })
          file.previewElement.getElementsByClassName('dz-progress')[0].style.display = 'none'
          return results
        },
        language: {
          dictDefaultMessage: this.$t('uploadArquivo.uploader.dictDefaultMessage'),
          dictFallbackMessage: this.$t('uploadArquivo.uploader.dictFallbackMessage'),
          dictFallbackText: this.$t('uploadArquivo.uploader.dictFallbackText'),
          dictFileTooBig: this.$t('uploadArquivo.uploader.dictFileTooBig'),
          dictInvalidFileType: this.$t('uploadArquivo.uploader.dictInvalidFileType'),
          dictResponseError: this.$t(this.errorMessage),
          dictMaxFilesExceeded: this.$t('uploadArquivo.uploader.dictMaxFilesExceeded'),
          dictRemoveFile: this.$t('uploadArquivo.uploader.dictRemoveFile')
        },
        headers: {
          'x-access-token': localStorage.getItem('token'),
          client: this.$store.getters.client
        }
      },
      spanError: 'uploadArquivo.uploader.envioFalhou',
      idLayoutFile: null,
      permissionUploadFile: false,
      uploadUrl: this.getUrlSendFile()
    }
  },

  computed: {
    client () {
      return this.$store.getters.client
    },

    expandedMenu () {
      return this.$store.getters.expandedMenu
    }
  },

  watch: {
    expandedMenu () {
      this.configPreviewWidth()
    }
  },

  methods: {
    // Carrega o layout dos arquivos configurado para o cliente
    loadLayout () {
      this.$store.dispatch('getFileLayout')
        .then((response) => {
          if (response && response.data && response.data.length > 0) {
            let canUploadFile = _.findWhere(response.data, { flUpload: true })
            if (canUploadFile) {
              this.layouts = JSON.stringify(response.data)
              this.availableLayouts = response.data
              this.permissionUploadFile = true
            } else {
              this.permissionUploadFile = false
            }
          } else {
            this.permissionUploadFile = false
          }
        }).catch(() => {
          this.permissionUploadFile = false
          this.$root.$refs.notification.error('uploadArquivo.erro.naoFoiPossivelBuscarLayouts')
        })
        .finally(() => {
          this.isLoadingData = false
        })
    },

    // Configuração do template das caixas exibidas dentro do dropzone (arquivos adicionados)
    fileListTemplate () {
      return `
        <div class="col-lg-6 col-md-12 dz-preview">
          <div class="upload-box">
            <i class="col-lg-1 col-md-1 upload-box-padding fa fa-file-code-o upload-box-fa-file" aria-hidden="true"></i>
            <div class="col-lg-10 col-md-10 upload-box-padding upload-box-info" style="background-color:transparent; height:40px;">
              <div class="details">
                <div class="filename pull-left">
                  <div style="cursor:pointer" class="fileUploadName">
                    <span data-dz-name/>
                  </div>
                </div>
                <div class="dz-error-mark dz-error-mark-message pull-left span-status" style="width: auto!important; top: 15%!important; position: sticky!important">
                  &nbsp-&nbsp` + this.$t(this.spanError) + `&nbsp
                  <div class="messageError">
                    <span data-dz-errormessage/>
                  </div>
                </div>
                <div class="size pull-right">
                  <span data-dz-size/>
                </div>
              </div>
              <div class="clear"></div>
              <div id='upload-progress-bar' class="border-radius-progress-bar dz-progress col-md-12 upload-box-padding">
                <span class="border-radius-progress-bar dz-upload" style="background-color: #17375F !important; height: 10px!important;" data-dz-uploadprogress></span>
              </div>
              <div class="border-radius-progress-bar dz-success-mark dz-success col-md-12 upload-box-padding" style="width:100%!important; background-color:#83E1BA; opacity:1!important ">
              </div>
              <div class="border-radius-progress-bar dz-error-mark dz-error col-md-12 upload-box-padding" style="width:100%!important; background-color:#F55753; ">
              </div>
            </div>
            <div class="col-lg-1 col-md-1 upload-box-padding text-center remover-arquivo">
              <a data-dz-remove title='Remover arquivo'>
                <i style="cursor:pointer" class="fa fa-times" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      `
    },

    // Envia os arquivos selecionados
    updateQueuedFiles (file) {
      const self = this
      this.validateNameAndRegex(file.name).then(layout => {
        self.$refs.fileUploadDZ.processQueue()
        trackAnalyticsEvent(this, 'file-upload', 'send-file', file.type)
        self.showInnerMessage = true
        if (file && file.name) {
          const fileName = truncateString(file.name, 12, 3)
          $(file.previewElement).find('.fileUploadName').text(fileName)
          $(file.previewElement).find('.fileUploadName').attr('title', file.name)
        }
        self.configPreviewWidth()
      }).catch((error) => {
        // Configura a mensagem de erro para ser exibida em cada arquivo no dropzone
        self.showErrorMessage(file, error)
        const fileAux = self.$refs.fileUploadDZ.getAcceptedFiles().find(fileUpload => fileUpload.name === file.name)
        fileAux.status = 'error'
        self.dropzoneOptions.error(file, error)
      })
    },

    validateNameAndRegex (filename) {
      // Percorre o array de layouts procurando uma regex válida,
      // caso não haja nenhuma regex válida, retorna uma mensagem de erro
      for (const layout of this.availableLayouts) {
        if (layout.mascara) {
          const regexp = new RegExp(layout.mascara)
          if (regexp.test(filename) && layout.flUpload) {
            return Promise.resolve(layout)
          }
        }
      }
      // Caso não haja regex cadastrada, retorna um erro
      return Promise.reject('uploadArquivo.erro.regex.naoEncontrada')
    },

    verifyDropzoneEmpty () {
      this.showInnerMessage = document.getElementsByClassName('dz-preview').length !== 0
    },

    getIdLayout (file) {
      for (const layout of this.availableLayouts) {
        const regexp = new RegExp(layout.mascara)
        if (regexp.test(file.name)) {
          return Promise.resolve(layout)
        }
      }
      return Promise.reject()
    },

    // Exibe a mensagem de erro retornada pelo middleware
    showErrorMessage (file, errorMessage) {
      errorMessage = this.$t(errorMessage)
      if (errorMessage && errorMessage.length > 20) {
        let errorTitle = errorMessage
        errorMessage = truncateString(errorMessage, 12, 8)
        $(file.previewElement).find('.messageError').attr('title', errorTitle)
        $(file.previewElement).find('.messageError').css({ 'cursor': 'pointer' })
      }
      trackAnalyticsEvent(this, 'file-upload', 'upload-error', errorMessage)
      $(file.previewElement).find('.messageError').text(errorMessage)
      if (file && file.name) {
        let fileName = truncateString(file.name, 5, 3)
        $(file.previewElement).find('.fileUploadName').text(fileName)
        $(file.previewElement).find('.fileUploadName').attr('title', file.name)
      }
    },

    saveAuditLog (file, response) {
      trackAnalyticsEvent(this, 'file-upload', 'upload-success', file.size)
      this.getIdLayout(file)
        .then(layout => {
          axios.post('/uploadFile/logAuditoria', { idLayout: layout.id })
        })
    },

    getUrlSendFile () {
      return getNodeMiddlewareUrl() + '/uploadFile'
    },

    // Configura o tamanho das divs com os previews dos arquivos enviados de acordo com o tamanho da tela e do estado do menu
    configPreviewWidth () {
      if (document.getElementsByClassName('dz-preview').length > 0) {
        let previewDivs = Array.from(document.getElementsByClassName('dz-preview'))
        let windowWidth = window.innerWidth
        if (windowWidth < 1299) {
          this.setClassToDiv(previewDivs, 'col-lg-6', 'col-lg-12')
        } else {
          if (this.expandedMenu && (windowWidth >= 1300 && windowWidth < 1501)) {
            this.setClassToDiv(previewDivs, 'col-lg-6', 'col-lg-12')
          } else {
            this.setClassToDiv(previewDivs, 'col-lg-12', 'col-lg-6')
          }
        }
      }
    },

    setClassToDiv (listDiv, classToRemove, classToAdd) {
      listDiv.forEach(item => {
        item.classList.remove(classToRemove)
        item.classList.add(classToAdd)
      })
    }
  },

  mounted () {
    this.configPreviewWidth()
    this.showInnerMessage = false
  },

  created () {
    this.loadLayout()
  }
}
</script>

<style lang="scss">
.upload-box-padding {
  padding: 0px!important;
}

.upload-label {
  text-transform: initial !important;
  color: #515151;
  font-weight: normal !important;
  font-size: 18px !important;
  margin: 20px 30px;
}

.upload-link {
  font-weight: bold !important;
}

.dz-message {
  font-size: 23px;
  color: #a9a9a9;
  font-family: 'Inter', sans-serif;
}

i.fa.fa-cloud-upload {
  font-size: 70px;
}

.upload-button {
  color: #fff;
  background: #17375f;
  border: 0px;
  font-size: 14px;
  padding: 10px;
  border-radius: 5px;
  font-family: 'Inter', sans-serif;
}

@media screen and (min-width: 1400px) {
  .upload-box-fa-file {
    font-size: 40px;
    font-weight: normal;
    padding-top: 3px!important;
  }

  .upload-box {
    /*width: 49%;*/
    border: 2px solid #bbbaba;
    margin-bottom: 10px;
    padding: 10px 0px 8px 20px;
    min-height: 70px;
  }

  .upload-box-info {
    margin: 0px;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1399px) {
  .upload-box-fa-file {
    font-size: 30px;
    font-weight: normal;
    padding-top: 7px!important;
  }

  .upload-box {
    /*width: 49%;*/
    border: 2px solid #bbbaba;
    margin-bottom: 10px;
    padding: 10px 0px 8px 10px;
    min-height: 70px;
  }

  .upload-box-info {
    margin: 0px 1% 0px 1%;
    width: 80%;
  }
}

@media screen and (max-width: 1199px) {
  .upload-box-fa-file {
    font-size: 40px;
    font-weight: normal;
    padding-top: 3px!important;
  }

  .upload-box {
    /*width: 49%;*/
    border: 2px solid #bbbaba;
    margin-bottom: 10px;
    padding: 10px 0px 8px 20px;
    min-height: 70px;
  }

  .upload-box-info {
    margin: 0px;
  }
}

.details {
  overflow: hidden;
  color: #696969;
  background-color: transparent;
  margin-top: 5px;
}

.error-label {
  color: red;
  font-size: 2vh;
  font-family: 'Inter', sans-serif;
}

.error-icon {
  color: red !important;
  font-size: 3vh;
}

.success-label {
  color: green;
  font-size: 2vh;
  font-family: 'Inter', sans-serif;
}

.success-icon {
  color: green !important;
  font-size: 3vh;
}

.error-mark {
  float: left;
  width: 100%;
  pointer-events: none;
  z-index: 100!important;
  margin-left: auto;
  margin-top: auto;
  opacity: 1;
  -webkit-animation: slide-in 3s cubic-bezier(.77, 0, .175, 1);
  animation: slide-in 3s cubic-bezier(.77, 0, .175, 1);
}

.dropzone .dz-preview .dz-progress {
  z-index: 102!important;
}

.dropzone .dz-preview .dz-success-mark {
  z-index: 100!important;
}

.dropzone .dz-preview .dz-error-mark {
  z-index: 101!important;
}

.dropzone .dz-preview:hover {
  z-index: 100!important;
}

.size {
  font-size: 12px;
  font-weight: bold;
}

.filename {
  font-size: 13px!important;
}

.dz-inner {
  text-align: center;
  color: #a9a9a9;
}

.error-message {
  pointer-events: none;
  z-index: 1000;
  display: none;
  opacity: 0;
  transition: opacity .3s ease;
  border-radius: 8px;
  font-size: 13px;
  width: 140px;
  background: linear-gradient(180deg, #be2626, #a92222);
  padding: .5em 1.2em;
  color: #fff;
  top: 90%;
  left: 70%;
}

#FileUploadWrapper>.dz-error-mark i {
  display: none!important;
}

.vue-dropzone {
  border: 2px dashed #d6d6d6 !important;
  font-family: 'Arial', sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  transition: background-color .2s linear;
  margin: 15px 0px 10px 0px;
  .dz-preview {
    .dz-details {
      overflow: hidden !important;
      color: #696969 !important;
      background-color: #fff !important;
      border: 2px solid #bbbaba !important;
    }
    .dz-remove {
      text-transform: initial !important;
      font-size: 2vh !important;
      color: #696969 !important;
      border: 2px solid #bbbaba !important;
      padding: .8vh !important;
    }
    .dz-error-message {
      top: 90% !important;
      left: 70% !important;
    }
  }
}

.dropzone .dz-preview {
  float: left!important;
  min-height: 70px!important;
  margin: 15px 0px 0px 0px!important;
}

.dropzone .dz-preview .dz-progress {
  opacity: 1;
  position: absolute;
  height: 10px!important;
  top: auto!important;
  bottom: 0px!important;
  left: 0px!important;
  margin-top: 0px!important;
  width: 100%!important;
  margin-left: 0px!important;
  background: hsla(0, 0%, 100%, .9)!important;
  -webkit-transform: scale(1);
  border-radius: 2px!important;
  overflow: hidden;
}

.dz-success {
  opacity: 1;
  position: absolute;
  height: 10px!important;
  top: auto!important;
  bottom: 0px!important;
  left: 0px!important;
  margin-top: 0px!important;
  transition: width .5s ease-in-out;
  border-radius: 2px!important;
  overflow: hidden;
}

.dz-error {
  opacity: 1;
  position: absolute;
  height: 10px!important;
  top: auto!important;
  bottom: 0px!important;
  left: 0px!important;
  margin-top: 0px!important;
  transition: width .5s ease-in-out;
  border-radius: 2px!important;
  overflow: hidden;
}

.dropzone .dz-preview .dz-progress .dz-upload {
  height: 10px!important;
  transition: width .3s ease-in-out;
}

.dz-error-mark-message {
  background: transparent!important;
}

span.dz-error-mark,
.dz-error-mark-label {
  opacity: 1;
  position: absolute!important;
  height: auto!important;
  top: auto!important;
  bottom: 0px!important;
  left: 0px!important;
  margin-top: -20px!important;
  width: 100%!important;
  margin-left: 0px!important;
  /*background: hsla(0,0%,100%,.9)!important;*/
  overflow: hidden;
}

.dz-success-mark {
  opacity: 1!important;
  -webkit-animation: none !important;
  -moz-animation: none !important;
  -ms-animation: none !important;
  -o-animation: none !important;
  animation: none !important;
  left: 0!important;
}

.dropzone .dz-preview.dz-error .dz-error-mark {
  opacity: 1!important;
  -webkit-animation: none!important;
  -moz-animation: none!important;
  -ms-animation: none!important;
  -o-animation: none!important;
  animation: none!important;
}

.dropzone .dz-preview .dz-success-mark svg,
.dropzone .dz-preview .dz-error-mark svg {
  display: block!important;
  width: 54px!important;
  height: 54px!important;
}

.remover-arquivo {
  font-size: 20px;
  height: 40px;
  color: #FFF;
  padding-top: 8px!important;
}

.span-status {
  font-style: italic;
  font-size: 12px;
  margin-top: 2px;
  color: #bdbdbd;
}

.messageError {
  float: right;
  font-style: normal;
  font-size: 12px;
  color: #34B8BA;
}

.border-radius-progress-bar {
  border-radius: 5px!important;
}

.upload-disabled {
  padding: 15px 0px;
  cursor: not-allowed;
}

i.icon-upload-disabled {
  font-size: 70px;
  color: #FF2B3F;
}

p.txt-upload-disabled {
  font-size: 24px;
}

.dropzone .dz-preview .dz-error-mark, .dropzone .dz-preview .dz-success-mark {
  pointer-events: auto!important;
}

.loadingData {
  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;
  cursor: wait;
  height: 390px;
  background-size: 100px;
}

.titulo{
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// FileUpload.vue?9858ebc2